import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

import { firebaseConfig } from './settings'

const app = initializeApp(firebaseConfig);

const Firestore = getFirestore(app);
const Auth = getAuth(app);
const Functions = getFunctions(app, 'europe-west1');
const Storage = getStorage(app);

// Enable App Check debug token in development
if (window.location.hostname === 'localhost') {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  console.log('App Check debug token enabled');
}

// Initialize App Check with reCAPTCHA v3
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LdmWTglAAAAAH1O94lRNEHRVyxTD2fkM4FASOEe'),
  isTokenAutoRefreshEnabled: true,
  
});

export { Firestore, Auth, Functions, Storage }
